import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './index.less';
export var CardSpaceWrapper = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    var View = useComponents().View;
    return (React.createElement(View, { className: styles['search-card-wrapper'] + " " + className, style: { padding: 15 }, onClick: onClick }, children));
};
